export default __webpack_public_path__ + "images/89b51d49c72e628fabc4cf877031cecc-food-box-outline.png";